import React from 'react';
function Home({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 9.6L12 4l7 5.6v8.8c0 .884-.696 1.6-1.556 1.6H6.556C5.696 20 5 19.284 5 18.4V9.6z"
        clipRule="evenodd"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 20v-8h6v8" />
    </svg>
  );
}

export default Home;
